import { UserType } from '@api/Users/User';
import { axiosPrivate } from '@api/ApiHelper/axiosPrivate';

export interface CustomerData {
    uid?: string;
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
    birthday: Date;
}

class CustomerService {
    saveCustomer = async (customerData: CustomerData): Promise<UserType> => {
        try {
            // Asegurar que la fecha esté en formato ISO
            const payload = {
                firstname: customerData.firstname,
                lastname: customerData.lastname,
                email: customerData.email,
                phone: customerData.phone,
                birthday: customerData.birthday.toISOString() // Convertir a ISO string
            };

            console.log('Enviando datos:', payload);

            const response = await axiosPrivate.post('/customers/', payload);
            console.log('Respuesta del servidor:', response.data);
            return response.data as UserType;
        } catch (error: any) {
            console.error('Error en saveCustomer:', error);

            // Mejor manejo de errores
            if (error.response) {
                // Error del servidor (409, 500, etc.)
                const serverError = error.response.data?.error || error.response.data?.message;
                throw new Error(serverError || 'Error del servidor');
            } else if (error.request) {
                // Error de red
                throw new Error('Error de conexión con el servidor');
            } else {
                // Otros errores
                throw new Error(error.message || 'Error desconocido');
            }
        }
    };
}

export default CustomerService;
